import { createAsyncThunk } from '@reduxjs/toolkit';

import { createAccessKey, createAccessKeyPublic, deleteAccessKey, deleteAccessKeyPublic, getAccessKey, getAccessKeyPublic, logout, refreshToken, verifyUser } from './cruds';

export const ACTION_TYPE_PARENT = 'auth'

// NOTE: keep function name and thunk child name same
export const fetchAccessKey = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchAccessKey`,
  async (userName: string, { rejectWithValue }) => {
    try {
      const response = await getAccessKey(userName)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)


// NOTE: keep function name and thunk child name same
export const fetchAccessKeyPublic = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchAccessKeyPublic`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAccessKeyPublic()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

// NOTE: keep function name and thunk child name same
export const generateAccessKey = createAsyncThunk(`${ACTION_TYPE_PARENT}/generateAccessKey`,
  async (userName: string, { rejectWithValue }) => {
    try {
      const response = await createAccessKey(userName)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const generateAccessKeyPublic = createAsyncThunk(`${ACTION_TYPE_PARENT}/generateAccessKeyPublic`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await createAccessKeyPublic()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const removeAccessKey = createAsyncThunk(`${ACTION_TYPE_PARENT}/removeAccessKey`,
  async (userName: string, { rejectWithValue }) => {
    try {
      const response = await deleteAccessKey(userName)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const removeAccessKeyPublic = createAsyncThunk(`${ACTION_TYPE_PARENT}/generateAccessKeyPublic`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await deleteAccessKeyPublic()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const logoutUser = createAsyncThunk(`${ACTION_TYPE_PARENT}/logoutUser`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await logout()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

export const refreshUserToken = createAsyncThunk(`${ACTION_TYPE_PARENT}/refreshUserToken`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await refreshToken()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

export const verifyUserForLogin = createAsyncThunk(`${ACTION_TYPE_PARENT}/verifyUserForLogin`,
  async ({ userName }: { userName: string }, { rejectWithValue }) => {
    try {
      const response = await verifyUser(userName)
      return response.status;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

